



// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Mixins } from "vue-mixin-decorator";
import { mapActions, mapGetters } from "vuex";

// Constants
import RouteNames from "@/constants/route-names.ts";
import Constants from "@/constants/constants";

// Views
import FormView from "@/shared/views/form.view.vue";
import ConvocationInfo from "@/clickbuy/purchase/views/convocation-info.view.vue";
import ClientModal from "@/clickbuy/convocation/views/participant-list/client-modal/index.vue";

// Components
import SelectTag from "@/shared/components/select.tag.component.vue";
import Input, {
  InputType,
  InputStyle
} from "@/shared/components/input.component.vue";
import RangeSlider from "@/shared/components/range-slider.component.vue";
import Field from "@/shared/components/field.component.vue";
import GroupButton from "@/shared/components/group-button.component.vue";
import TextArea, {
  TextareaPredefinedStyle
} from "@/shared/components/text-area.component.vue";
import Checkbox, {
  CheckboxPredefinedStyle
} from "@/shared/components/checkbox.component.vue";
import Btn, {
  BtnPredefinedStyle,
  BtnColor,
  BtnWidth,
  BtnHeight
} from "@/shared/components/btn.component.vue";
import Dropdown, {
  DropdownWidth,
  DropdownStyle
} from "@/shared/components/Dropdown.component.vue";
import SpotlightText, {
  SpotlightTextColor,
} from "@/shared/components/SpotlightText.component.vue";
import CheckIcon, {
  CheckIconColor,
} from "@/shared/components/CheckIcon.component.vue";
import Icon, { IconEnum } from "@/shared/components/icon.component.vue";
import Tooltip, {
  TooltipColor,
} from "@/shared/components/Tooltip.component.vue";

// Models
import {
  Purchase,
  PaymentMethod,
  PurchasePaymentStatus,
  PurchaseCompletionStatus
} from "@/clickbuy/purchase/models/purchase.model.ts";
import { SaleInfoProductInterface } from "@/clickbuy/purchase/models/sale-info.model.ts";
import { Participant } from "@/manager/convocation/participant.model";
import { ClientStatus, Client } from "@/manager/client/client.model";
import SearchAutocomplete from "@/shared/components/SearchAutocomplete.component.vue";
import FlatSelectorText, {
  FlatSelectorTextPredefinedStyle,
  FlatSelectorTextSize,
} from "@/shared/components/FlatSelectorText.component.vue";
import {
  BudgetPaymentMethod,
  BudgetPaymentStatus,
} from '@/manager/budget/models/budget.model';
import ChoosePaymentMethod from '@/client/budget/views/acceptance/choose-payment-method/index.vue';
import {
  Budget,
} from '@/manager/budget/models/budget.model';


// Mixins
import ErrorMixin from "@/shared/mixins/error.mixin";
import NotificationMessage from '@/shared/mixins/notificationMessage.mixin.ts';

// Services
import UtilsService from "@/core/services/utils.service";
import ClientService from "@/manager/client/client.service";

import Assets from "@/constants/assets.ts";
import Modal, {
  ModalTitleColor,
} from "@/shared/components/Modal.component.vue";

// Third party
import dayjs from 'dayjs';
import 'dayjs/locale/es';

// interface MixinInterface extends ErrorMixin {}
interface MixinInterface extends ErrorMixin, NotificationMessage { }

@Component({
  components: {
    Btn,
    SelectTag,
    Icon,
    Checkbox,
    CheckIcon,
    ClientModal,
    Modal,
    ConvocationInfo,
    Field,
    FormView,
    GroupButton,
    Input,
    Dropdown,
    RangeSlider,
    TextArea,
    SearchAutocomplete,
    SpotlightText,
    FlatSelectorText,
    ChoosePaymentMethod
  },
  computed: {
    ...mapGetters({
      currentPurchase: "getCurrentPurchase",
      purchaseTagList: "getPurchaseTagList",
      getParticipant: "getParticipant",
      getSelectedClient: "getSelectedClient",
      hasClientSelected: "currentPurchaseHasClient",
      getClient: "getClient",
      userMoneyFlow: "getUserMoneyFlow",
      hasUserMoneyFlow: "hasUserMoneyFlow",
      acquiredCourses: 'acquiredCoursesList',
      clientList: "getClientList",
      currentBudget: 'getCurrentBudgetAcceptance',
      isCardMethodSelected: 'isCardMethodSelectedInCurrentBudgetAcceptance',
      isDirectDebitMethodSelected:
        'isDirectDebitMethodSelectedInCurrentBudgetAcceptance',
    })
  },
  methods: {
    ...mapActions({
      setCurrentBudget: 'setCurrentBudgetAcceptance',
    })
  },
})
export default class PurchaseForm extends Mixins<MixinInterface>(ErrorMixin, NotificationMessage) {
  @Prop() private convocationId!: string;
  @Prop() private participantId!: string;

  private assets = Assets;
  private btnPredefinedStyle = BtnPredefinedStyle;
  private textareaPredefinedStyle = TextareaPredefinedStyle;
  private checkboxPredefinedStyle = CheckboxPredefinedStyle;
  private iconEnum = IconEnum;
  private checkIconColor = CheckIconColor;
  private tooltipColor = TooltipColor;

  private dropdownWidth = DropdownWidth;
  private DropdownStyle = DropdownStyle;
  private btnColor = BtnColor;
  private btnWidth = BtnWidth;
  private btnHeight = BtnHeight;
  private inputType = InputType;
  private inputStyle = InputStyle;
  private purchase = new Purchase();
  private verifyData = true;
  private purchaseConditions = true;
  private productSelected: SaleInfoProductInterface = {};
  private flatSelectorTextPredefinedStyle = FlatSelectorTextPredefinedStyle;
  private flatSelectorTextSize = FlatSelectorTextSize;
  private productTypeSelected = this.fiscalDataExtensionsList[0];
  // private productTypeSelected:any
  private hasClientSelected!: any;
  private currentPurchase!: any;
  private nifMask = "";
  private getParticipant!: any;
  private userMoneyFlow!: any;
  private hasUserMoneyFlow!: any;
  private disableSendFormBtn = false;
  private showCustomerModal = false;
  private newClient = new Client();
  private addExistingClient = false;
  private acquiredCourses!: any;
  private updateFiscalDataExtension = false;
  private isDefaultFiscalData = true;
  private searchString = "";
  private searchPhoneString = "+34";
  private getClient!: any;
  private selectedClient!: any;
  private getSelectedClient!: any;
  private isDeleteModalOpened = false;
  private modalTitleColor = ModalTitleColor;
  private clientType = '';
  private fiscalData = {
    'user': '',
    'userId': '',
    'email': '',
    'address': '',
    'postalCode': '',
    'country': '',
    'town': '',
    'state': '',
    'firstName': '',
    'lastName': '',
    'secondLastName': '',
    'nif': '',
    'phone': ' ',
    'id': '',
    'isDefault': false
  };
  private selectNewFiscalData: any;
  private isNewFiscalDataExtension = false;
  private searchStringFiscalData = ""
  private selectedOptionFiscalData!: any;
  private selectedClientFiscalData!: any
  private rescatarFiscalDataBool = false
  private searchFiscalDataExtensionsList: any = [];
  private clientCountryList: any = [];
  private clientProvinceList: any = [];
  private clientPostalCodeList: any = [];
  private showAddPaymentInfoBoolean: any = false
  private currentBudget?: any;
  private isCardMethodSelected!: any;
  private isDirectDebitMethodSelected!: any;
  private newPaymentAdded: any = false
  private clientPayments: any
  private clientPaymentSelected: any = this.clientPayments ? this.clientPayments[0] : '';
  private setCurrentBudget!: any;
  private savedFiscalDataBool: Boolean = false;
  private zipcodes: any;
  private updateKey: any;


  public error: any = {
    fiscalData: {
      postalCode: "",
      nif: "",
      firstName: "",
      lastName: "",
      email: "",
    },
    client: {
      user: {
        email: "",
        firstName: "",
        lastName: "",
        profile: {
          nif: "",
          phone: "",
          town: ""
        }
      }
    },
    purchase: {
      cardLastDigits: ""
    }
  };
  get fiscalDataExtensionsList(): any[] {
    return [
      { nif: 'seleccione' },
      { nif: 'Avenida Gabriel Roca, 8, piso 3' },
      { nif: 'Calle Rafel Rodriguez Mendez, 1, piso 2A' },
    ];
  }

  get provinceSelected() {
    const provinceId: any = this.fiscalData.state;
    let result = {
      value: "",
      label: ""
    };

    if (provinceId != 'SIN DATOS' && typeof provinceId === "string") {
      result = this.clientProvinceList.find((option: any) => {
        return option.value === provinceId;
      });
    } else if (typeof provinceId === 'object' && provinceId !== null && provinceId.value) {
      result = this.clientProvinceList.find((option: any) => {
        return option.value === provinceId.value;
      });
    }

    this.fetchPostalCodeList(provinceId);
    return result;
  }

  get countrySelected() {
    const countryId: any = this.fiscalData.country;
    let result = {
      value: "",
      label: ""
    };

    if (countryId != 'SIN DATOS' && typeof countryId === "string") {
      result = this.clientCountryList.find((option: any) => {
        return option.value === countryId;
      });
    } else if (typeof countryId === 'object' && countryId !== null && countryId.value) {
      result = this.clientCountryList.find((option: any) => {
        return option.value === countryId.value;
      });
    }

    // this.fetchPostalCodeList(countryId);
    return result;
  }

  get isOldTLP() {
    return this.client.oldTopLevelPack;
  }

  get tooltipTextTLP() {
    let text = 'Top Level Pack';
    if (this.isOldTLP) {
      text = 'TLP Antiguo';
    }
    return text;
  }

  get tooltipTextPWP() {
    let text = 'Power Pack';
    return text;
  }

  get tooltipTextCN3() {
    let text = 'Certificado de nivel 3';
    return text;
  }

  get topLevelPackIconColor() {
    let color = this.checkIconColor.Gold;
    if (this.isOldTLP) {
      color = this.checkIconColor.GoldDark;
    }
    if (this.selectedClient.tlp) {
      color = this.selectedClient.tlp.color;
    }
    return color;
  }

  get topLevelPackTooltipColor() {
    let color = this.tooltipColor.Secondary;
    return color;
  }

  get powerPackIconColor() {
    let color = this.checkIconColor.Gold;
    if (this.selectedClient.pwp) {
      color = this.selectedClient.pwp.color;
    }
    return color;
  }

  get powerPackTooltipColor() {
    let color = this.tooltipColor.Secondary;
    return color;
  }


  @Watch("searchStringFiscalData")
  public watchsearchStringFiscalData(newVal: any, oldVal: any) {

    if (this.searchTimeout != null) {
      clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(() => {
      this.searchFDCallback();
    }, 1000);

  }

  @Watch("productTypeSelected")
  private watchProductTypeSelected(newVal: any, oldVal: any) {
    this.isNewFiscalDataExtension = false;
    this.isDefaultFiscalData = false;
    this.fiscalData = {
      'user': newVal.userId,
      'userId': '',
      'email': newVal.email || 'SIN@DATOS.COM',
      'address': newVal.address || 'SIN DATOS',
      'postalCode': newVal.postalCode,
      'country': newVal.country || 'SIN DATOS',
      'town': newVal.town || 'SIN DATOS',
      'state': newVal.state || 'SIN DATOS',
      'firstName': newVal.firstName || 'SIN DATOS',
      'lastName': newVal.lastName || 'SIN DATOS',
      'secondLastName': newVal.secondLastName || 'SIN DATOS',
      'nif': newVal.nif,
      'phone': newVal.phone || '34',
      'id': newVal.id,
      'isDefault': false
    }
    this.purchase.fiscalData = this.fiscalData;
    this.purchase.fiscalDataExtensionId = this.fiscalData.id;
    this.currentPurchase.fiscalData = this.fiscalData;
    this.currentPurchase.fiscalDataExtensionId = this.fiscalData.id;
    // this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
    this.$store.dispatch("setCurrentPurchase", this.currentPurchase);
  }

  private watchCardLastDigits(newVal: any, oldVal: any) {
    this.purchase.cardLastDigits = newVal
    this.currentPurchase.cardLastDigits = newVal

    const paymentMethodsParent = document.getElementById('paymentMethods');
    if (paymentMethodsParent) {
      // Verificar si el elemento padre existe
      const elementosConClase:any = paymentMethodsParent.getElementsByClassName('button--active')[0];

      if (elementosConClase) {
        elementosConClase.click()
      }
    }

    this.$store.dispatch("setCurrentPurchase", this.currentPurchase);
  }

  private setProvince() {
    setTimeout(() => {
      let result = this.clientPostalCodeList.find((option: any) => {
        return option.value.slice(0, 2) === this.fiscalData.postalCode.slice(0, 2);
      });

      if (this.fiscalData.postalCode.length == 5) {
        let zipCodesResults = this.zipcodes.filter((zipcode: any) => zipcode.zipcode === this.fiscalData.postalCode);
        if (zipCodesResults.length > 0) {
          this.fiscalData.town = zipCodesResults[0].place
        }
      }

      if (result) {
        this.fiscalData.country = result.country;
        this.fiscalData.state = result.province;
      }
    }, 1000);
  }

  private fetchProvinceList() {
    this.$store.dispatch("fetchClientProvinceList").then((res) => {
      this.clientProvinceList = res.map((e: any) => {
        const option = {
          value: e.name,
          label: e.name,
        };
        return option;
      });
      this.updateKey++;
    });
  }

  private fetchCountryList() {
    this.$store.dispatch("fetchClientCountryList").then((res) => {
      this.clientCountryList = res.map((e: any) => {
        const option = {
          value: e.name,
          label: e.name,
        };
        return option;
      });
      this.updateKey++;
    });
  }

  private fetchPostalCodeList(province: any) {
    this.$store.dispatch("fetchClientPostalCodeList", /* province */).then((res) => {
      this.clientPostalCodeList = res.map((e: any) => {
        const option = {
          value: e.name || '',
          label: e.name || '',
          province: e.province ? e.province.name : '',
          country: e.province && e.province.country ? e.province.country.name : ''
        };
        return option;
      });
    });
  }

  private updateCP(province: any) {
    this.fetchPostalCodeList(province.value);
  }

  get postalCodeSelected() {
    const postalCodeId = this.client.user.profile.postalCode;
    let result = {};
    if (postalCodeId) {
      result = this.clientPostalCodeList.find((option: any) => {
        return option.value === postalCodeId;
      });
    }
    return result;
  }

  private updateCurrentFiscalDataExtension() {
    this.updateFiscalDataExtension = true;
    this.setCurrentFiscalDataExtension()
  }

  private checkCurrentFiscalDataExtension() {
    if (this.fiscalData.id == '' || this.fiscalData.user == '') {
      this.setCurrentFiscalDataExtension()
    }
  }

  private setCurrentFiscalDataExtension() {
    let defaultExtension = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.isDefault);
    if (this.isDefaultFiscalData) {
      if (defaultExtension.length > 0) {
        this.fiscalData = {
          'user': this.acquiredCourses.userId,
          'userId': '',
          'email': this.acquiredCourses.fiscalData.email || 'SIN@DATOS.COM',
          'address': this.acquiredCourses.fiscalData.address || 'SIN DATOS',
          'postalCode': this.acquiredCourses.fiscalData.postalCode,
          'country': this.acquiredCourses.fiscalData.country || 'SIN DATOS',
          'town': this.acquiredCourses.fiscalData.town || 'SIN DATOS',
          'state': this.acquiredCourses.fiscalData.state || 'SIN DATOS',
          'firstName': this.acquiredCourses.fiscalData.firstName || 'SIN DATOS',
          'lastName': this.acquiredCourses.fiscalData.lastName || 'SIN DATOS',
          'secondLastName': this.acquiredCourses.fiscalData.secondLastName || 'SIN DATOS',
          'nif': this.acquiredCourses.fiscalData.nif,
          'phone': this.acquiredCourses.fiscalData.phone || 'SIN DATOS',
          'id': defaultExtension[0].id,
          'isDefault': true
        }
      } else {
        this.fiscalData = {
          'user': this.acquiredCourses.userId,
          'userId': '',
          'email': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.email : 'SIN@DATOS.COM',
          'address': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.address : 'SIN DATOS',
          'postalCode': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.postalCode : '',
          'country': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.country : 'SIN DATOS',
          'town': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.town : 'SIN DATOS',
          'state': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.state : 'SIN DATOS',
          'firstName': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.firstName : 'SIN DATOS',
          'lastName': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.lastName : 'SIN DATOS',
          'secondLastName': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.secondLastName : 'SIN DATOS',
          'nif': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.nif : '',
          'phone': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.phone : '34',
          'id':'',
          "isDefault": true
        }
      }
    }
  }

  private patchFiscalDataExtension(data: any, userId: any, id: any) {
    if (this.checkMandatoryFieldsAddFiscalData()) {
      this.updateFiscalDataExtension = false;
      if (data.phone) {
        data.phone = data.phone.replaceAll(/\s/g, '');
      }
      // data = {'isDefault': data};
      const payload = {
        id,
        userId,
        data,
      };
      this.$store.dispatch('patchFiscalDataExtension', payload);
      setTimeout(() => {
        // this.fetchFiscalDataExtensionsList();
      }, 1000);
    }
    // 2000
  }

  private patchFiscalDataDefaultExtension(data: any, userId: any, id: any) {
    if (this.checkMandatoryFieldsAddFiscalData()) {
      this.updateFiscalDataExtension = false;
      // data = {'isDefault': data};
      data.isDefault = true;
      if (data.phone) {
        data.phone = data.phone.replaceAll(/\s/g, '');
      }
      const payload = {
        id,
        userId,
        data,
      };
      this.$store.dispatch('patchFiscalDataExtension', payload).then(
        res => {
          this.savedFiscalDataBool = true
          this.$store.dispatch("fetchAcquiredCoursesList", { id: userId })
          this.showMessage("Cambios realizados correctamente")
        }
      );
      setTimeout(() => {
        // this.fetchFiscalDataExtensionsList();
      }, 1000);
    }
    // 2000
  }

  private showMessage(message: any) {
    let color = this.ownSpotlightTextColor.Primary;
    let text = message;
    if (message.error) {
      color = this.ownSpotlightTextColor.Error;
    }
    if (message.message) {
      text = message.message;
    }
    this.showNotification(text, color);
  }

  private newFiscalDataExtension() {
    this.isDefaultFiscalData = false;
    this.isNewFiscalDataExtension = true;
    this.fiscalData = {
      'user': this.acquiredCourses.userId,
      'userId': '',
      'email': 'SIN@DATOS.COM',
      'address': 'SIN DATOS',
      'postalCode': '',
      'country': 'SIN DATOS',
      'town': 'SIN DATOS',
      'state': 'SIN DATOS',
      'firstName': 'SIN DATOS',
      'lastName': 'SIN DATOS',
      'secondLastName': 'SIN DATOS',
      'nif': '',
      'phone': '+34',
      'id': '',
      'isDefault': false
    }
  }

  private addFiscalDataExtension(fiscalData: any, status?: any) {
    if (this.checkMandatoryFieldsAddFiscalData()) {
      if (status) {
        fiscalData.isDefault = status
      } else if (this.acquiredCourses && this.acquiredCourses.fiscalDataExtensions && this.acquiredCourses.fiscalDataExtensions.length == 0) {
        // If is new fiscal data and it's the first one
        fiscalData.isDefault = true
      } else {
        fiscalData.isDefault = false
      }
      if (fiscalData.phone) {
        fiscalData.phone = fiscalData.phone.replaceAll(/\s/g, '');
      }
      this.isNewFiscalDataExtension = false;
      this.updateFiscalDataExtension = false;
      this.rescatarFiscalDataBool = false;
      this.$store.dispatch('newFiscalDataExtension', fiscalData).then(
        res => {
          this.selectNewFiscalData = res.id
          this.currentPurchase.fiscalData = res;
          this.currentPurchase.fiscalDataExtensionId = res.id;
          this.purchase.fiscalData = res;
          this.purchase.fiscalDataExtensionId = res.id;
          this.$store.dispatch("fetchAcquiredCoursesList", { id: fiscalData.user })
          // this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
          this.$store.dispatch("setCurrentPurchase", this.currentPurchase);
          this.showMessage("Datos fiscales guardados correctamente")
          this.savedFiscalDataBool = true
        },
        err => {
          this.showMessage("Error al subir datos")
        }
      );
    }
  }

  private readOnly: any = {
    firstName: true,
    lastName: true,
    town: true,
    nif: true,
    email: true,
    phone: true
  };
  private serverError = "";
  private literals = {
    bonoCheckbox: "Aplicar precio de bono",
    conferenceInsuranceCheckbox: "Aplicar precio de Confe + Seguro",
    discount: "Saldo a favor"
  };
  private searchTimeout: any = null


  @Watch("purchase.client.user.profile.nif")
  private watchNif(newVal: string, oldVal: string) {
    if (!newVal) {
      newVal = "";
    }
    this.nifMask = UtilsService.setNifMask(newVal, this.nifMask);
  }

  @Watch("searchString")
  public watchsearchString(newVal: any, oldVal: any) {
    if (this.searchTimeout != null) {
      clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(() => {
      this.searchCallback();
    }, 500);
  }

  @Watch("searchPhoneString")
  public watchsearchPhoneString(newVal: any, oldVal: any) {
    if (this.searchTimeout != null) {
      clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(() => {
      this.searchCallback();
    }, 500);
  }

  @Watch("getSelectedClient")
  public watchGetSelectedClient(newVal: any, oldVal: any) {
    if (newVal) {
      this.selectClient(newVal);
    }
  }

  @Watch('purchase.client.user.profile.phone')
  private watchPhone(newVal: any, oldVal: any) {
    if (!newVal) {
      (this.purchase.client.user as any).profile.phone = '+';
    } else if (newVal.charAt(0) != '+') {
      newVal = '+' + newVal;
      (this.purchase.client.user as any).profile.phone = newVal;
    } else {
      (this.purchase.client.user as any).profile.phone = newVal;
    }
  }

  @Watch("acquiredCourses")
  private setProductTypeSelected(newVal: any, oldVal: any) {
    this.fetchClientPayment(0);
    this.rescatarFiscalDataBool = false;
    if (this.acquiredCourses && this.acquiredCourses.fiscalDataExtensions && this.acquiredCourses.fiscalDataExtensions.length > 0 && this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.isDefault)[0]) {
      this.checkCurrentFiscalDataExtension()
      if (this.selectNewFiscalData) {
        this.productTypeSelected = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.id == this.selectNewFiscalData)[0];
        this.selectNewFiscalData = undefined
      } else {
        this.productTypeSelected = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.isDefault)[0];
      }
      this.purchase.fiscalData = this.fiscalData;
      this.purchase.fiscalDataExtensionId = this.fiscalData.id;
      this.currentPurchase.fiscalData = this.fiscalData;
      this.currentPurchase.fiscalDataExtensionId = this.fiscalData.id;
      // this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
      this.$store.dispatch("setCurrentPurchase", this.currentPurchase);
    } else {
      this.productTypeSelected = this.fiscalDataExtensionsList[0];
    }
  }

  // @Watch('fiscalData.phone')
  // private watchFiscalPhone(newVal: any, oldVal: any) {
  //   if (!newVal) {
  //     this.fiscalData.phone = '+';
  //   } else if (newVal.charAt(0) != '+') {
  //     newVal = '+' + newVal;
  //     this.fiscalData.phone = newVal;
  //   } else {
  //     this.fiscalData.phone = newVal;
  //   }
  // }

  private created() {
    this.setUserMoneyFlow(0);
    this.checkParticipantToFillForm();
    this.checkReadOnlyFields();
    this.fetchPurchaseTags();
    this.searchCallback();
    this.fetchProvinceList();
    this.fetchCountryList();
  }

  private mounted() {
    this.setScrollParentNode();
    this.zipcodes = this.assets.zipCodesJson
  }

  private fetchPurchaseTags() {
    this.$store.dispatch("fetchPurchaseTagList").then(res => { }, err => { });
  }
  set purchaseTagListSelected(value) {
    this.purchase.tags = value;
  }
  get purchaseTagListSelected(): Array<Record<string, string>> {
    return (this.purchase.tags || []).map((e: any) => {
      return { ...e, active: true };
    });
  }
  get priceApplied(): number {
    let productConferencePrice = this.productSelected.conference || 0;
    if (this.purchase.purchaseLines[0].useBonoPrice) {
      productConferencePrice = this.productSelected.bono || 0;
    } else if (this.purchase.purchaseLines[0].useConferenceInsurance) {
      productConferencePrice = this.productSelected.conferenceInsurance || 0;
    }
    return productConferencePrice;
  }

  get totalPurchase(): number {
    return this.priceApplied * (this.purchase.purchaseLines[0] as any).amount;
  }

  get totalPurchaseWithDiscount(): number {
    let total = this.totalPurchase;
    total -= this.userMoneyFlow;
    if (total < 0) {
      total = 0;
    }
    return total;
  }

  get paymentOptions() {
    return [
      {
        id: PaymentMethod.Cash.toString(),
        text: "Efectivo"
      },
      {
        id: PaymentMethod.Card.toString(),
        text: "Tarjeta"
      },
      {
        id: PaymentMethod.SendWireTransfer.toString(),
        text: "Transferencia"
      },
      {
        id: PaymentMethod.Bizum.toString(),
        text: "Bizum"
      },
      {
        id: PaymentMethod.Web.toString(),
        text: "Web"
      },
      {
        id: PaymentMethod.DirectDebit.toString(),
        text: "Domiciliación"
      },
    ];
  }

  get participant() {
    return this.getParticipant(this.participantId);
  }

  get hasServerError() {
    return this.serverError !== "";
  }

  get productHasBonoPrice() {
    return this.productSelected.bono !== 0;
  }

  get productHasConferenceInsurancePrice() {
    return this.productSelected.conferenceInsurance !== 0;
  }

  get formComplete() {
    return (
      (this.purchase.client.user as any).firstName !== "" &&
      (this.purchase.client.user as any).lastName !== "" &&
      (this.purchase.client.user as any).profile.nif !== "" &&
      (this.purchase.client.user as any).profile.phone !== "" &&
      // (this.purchase.client.user as any).profile.town !== "" &&
      // (this.purchase.client.user as any).profile.address !== "" &&
      // (this.purchase.client.user as any).profile.postalCode !== "" &&
      (this.purchase.client.user as any).email !== "" &&
      this.purchase.paymentMethod &&
      (this.purchase.paymentMethod as any).id !== -1 &&
      this.verifyData &&
      this.purchaseConditions
    );
  }

  get fullName() {
    let name = `${(this.purchase.client.user as any).firstName} ${(this.purchase.client.user as any).lastName
      }`;
    if (name === " ") {
      name = "Nuevo cliente";
    }
    return name;
  }

  private checkReadOnlyFields() {
    this.readOnly = {
      firstName: this.isReadOnly((this.purchase.client.user as any).firstName),
      lastName: this.isReadOnly((this.purchase.client.user as any).lastName),
      // town: this.isReadOnly((this.purchase.client.user as any).profile.town),
      // address: this.isReadOnly(
      //   (this.purchase.client.user as any).profile.address
      // ),
      // postalCode: this.isReadOnly(
      //   (this.purchase.client.user as any).profile.postalCode
      // ),
      nif: this.isReadOnly((this.purchase.client.user as any).profile.nif),
      email: this.isReadOnly((this.purchase.client.user as any).email),
      phone: this.isReadOnly((this.purchase.client.user as any).profile.phone)
    };
  }

  private isReadOnly(value: any) {
    return false;
    if (!value) {
      value = "";
    }
    const val = String(value);

    return (
      ((this.participant &&
        this.participant.client.status === ClientStatus.Customer) ||
        this.addExistingClient) &&
      val !== ""
    );
  }

  private useExistingClient() {
    this.addExistingClient = true;
    this.purchase.client = this.newClient;
    this.nifMask = "";
    this.showCustomerModal = false;
    setTimeout(() => {
      this.checkReadOnlyFields();
      this.sendForm();
    }, 0);
  }

  private setScrollParentNode() {
    this.parentNode = document.getElementsByClassName("form-view__content")[0];
  }

  private clearTextArea() {
    this.purchase.note = "";
  }

  private fetchAquiredCourses() {
    return this.$store.dispatch("fetchAcquiredCoursesList", {
      id: this.purchase.client.user.id
    }).then(() => {
      this.fillFiscalDataFormExistingClient();
    });;
  }

  private checkServerError(err: any) {
    const response = err.response;
    if (response.status === 500) {
      this.serverError =
        "Estamos sufriendo algún problema... Inténtalo de nuevo";
    } else if (response.statusText) {
      this.serverError = response.statusText;
      if (response.data.phone) {
        this.serverError += ": " + response.data.phone
      } else if (response.data.client.user.profile.nif) {
        this.serverError += ": " + response.data.client.user.profile.nif
      } else if (response.data.client.user.profile.phone) {
        this.serverError += ": " + response.data.client.user.profile.phone
      }
    } else {
      this.serverError = "";
    }
    // setTimeout(() => {
    //   this.serverError = "";
    // }, Constants.notificationMessageTimeToAppear);
  }

  private setPurchaseFormError(err: any) {
    const serverError = err.response.data;
    this.error = { ...this.error, ...serverError };
  }

  private checkMandatoryFields() {
    let result = true;

    if (!this.verifyData) {
      this.error.verifyData = "error";
      result = false;
    }
    if (!this.purchaseConditions) {
      this.error.purchaseConditions = "error";
      result = false;
    }
    if ((this.purchase.client.user as any).firstName === "") {
      this.error.client.user.firstName = "Campo vacío";
      result = false;
    }
    if ((this.purchase.client.user as any).lastName === "") {
      this.error.client.user.lastName = "Campo vacío";
      result = false;
    }
    if ((this.purchase.client.user as any).email === "") {
      this.error.client.user.email = "Campo vacío";
      result = false;
    }
    if (this.purchase.paymentMethod == 2 && !this.purchase.cardLastDigits) {
      this.error.purchase.cardLastDigits = "Campo vacío";
      result = false;
    }
    const nif = (this.purchase.client.user as any).profile.nif;
    if (!nif || nif === "") {
      this.error.client.user.profile.nif = "Campo vacío";
      result = false;
    }

    // const purchasFiscalDataExtension = (this.purchase as any).fiscalDataExtensionId;
    // if (!purchasFiscalDataExtension || purchasFiscalDataExtension === "") {
    //   result = false;
    // }

    return result;
  }

  private checkMandatoryFieldsAddFiscalData() {
    let result = true;

    // Validación fiscal data
    const fiscalDataNif = (this.fiscalData as any).nif;
    if (!fiscalDataNif || fiscalDataNif === "") {
      this.error.fiscalData.nif = "Campo vacío";
      result = false;
    }

    const postalCode = (this.fiscalData as any).postalCode;
    if (!postalCode || postalCode === "") {
      this.error.fiscalData.postalCode = "Campo vacío";
      result = false;
    } else if (!postalCode || postalCode.trim().length < 5) {
      this.error.fiscalData.postalCode = "CP está incompleto";
      result = false;
    }

    const firstName = (this.fiscalData as any).firstName;
    if (!firstName || firstName === "" || firstName === "SIN DATOS") {
      this.error.fiscalData.firstName = "Campo obligatorio";
      result = false;
    }

    const lastName = (this.fiscalData as any).lastName;
    if (!lastName || lastName === "" || lastName === "SIN DATOS") {
      this.error.fiscalData.lastName = "Campo obligatorio";
      result = false;
    }

    const email = (this.fiscalData as any).email;
    if (!email || email === "" || email === "SIN@DATOS.COM") {
      this.error.fiscalData.email = "Campo obligatorio";
      result = false;
    }
    return result;
  }

  private closeClientModal(callback: any) {
    this.showCustomerModal = false;
    callback();
  }

  private productChange(
    product: SaleInfoProductInterface,
    convocationId: string
  ) {
    this.productSelected = product;
    this.$set(this.purchase, "convocationOrigin", this.convocationId);
    this.$set(
      this.purchase.purchaseLines[0],
      "convocationTarget",
      convocationId
    );
    this.$set(this.purchase.purchaseLines[0], "product", (product as any).id);
    this.$set(this.purchase.purchaseLines[0], "productName", product.name);
    this.$set(this.purchase.purchaseLines[0], "totalPrice", this.totalPurchase);
  }

  private backToConvocation() {
    this.$router.push({
      name: "cb-participantList",
      params: { id: this.convocationId }
    });
  }

  private checkParticipantToFillForm() {
    const queryEmail = this.$route.query.email;
    if (this.participant) {
      this.fetchUserMoneyFlow();
      this.fillForm(this.participant);
    } else if (this.participantId !== "new") {
      this.fetchParticipant(() => {
        this.fetchUserMoneyFlow();
        this.fillForm(this.participant);
      });
    } else if (queryEmail) {
      (this.purchase.client.user as any).email = queryEmail;
    }
    setTimeout(() => {
      this.fetchAquiredCourses();
      if (this.participant && this.participant.client && this.participant.client.status == 1) {
        this.clientType = "Potencial";
      } else if (this.participant && this.participant.client && this.participant.client.status == 2) {
        this.clientType = "Cliente";
      } else {
        this.clientType = "Potencial";
      }
    }, 1000);
  }

  private fillForm(participant: Participant) {
    (this.purchase.client.user as any).id = this.participant.client.user.id;
    (this.purchase.client
      .user as any).firstName = this.participant.client.user.firstName;
    (this.purchase.client
      .user as any).lastName = this.participant.client.user.lastName;
    (this.purchase.client
      .user as any).secondLastName = this.participant.client.user.secondLastName;
    (this.purchase.client
      .user as any).profile.nif = this.participant.client.user.profile.nif;
    (this.purchase.client
      .user as any).profile.phone = this.participant.client.user.profile.phone;
    // (this.purchase.client
    //   .user as any).profile.town = this.participant.client.user.profile.town;
    // (this.purchase.client
    //   .user as any).profile.address = this.participant.client.user.profile.address;
    // (this.purchase.client
    //   .user as any).profile.postalCode = this.participant.client.user.profile.postalCode;
    (this.purchase.client
      .user as any).email = this.participant.client.user.email;
  }

  private setUserMoneyFlow(amount: number) {
    this.$store.dispatch("setUserMoneyFlow", amount);
  }

  private fetchUserMoneyFlow() {
    this.$store.dispatch("fetchUserMoneyFlow", {
      id: this.participant.client.user.id
    });
  }

  private checkEmail(
    callback = () => {
      const doNothing = 1;
    }
  ) {
    if (this.participantId === "new" && !this.addExistingClient) {
      ClientService.isEmailInUse((this.purchase.client.user as any).email).then(
        res => {
          callback();
        },
        err => {
          this.newClient = err.response.data.client;
          this.$store.dispatch("addClientToStore", this.newClient);
          this.showCustomerModal = true;
        }
      );
    } else {
      callback();
    }
  }

  private fetchParticipant(
    callback = () => {
      const doNothing = 1;
    },
    id = this.participantId
  ) {
    this.$store.dispatch("fetchParticipant", { id }).then(() => {
      callback();
    });
  }

  private setPaymentStatus() {
    this.purchase.paymentStatus = PurchasePaymentStatus.Paid;
  }

  private setCompletionStatus() {
    if (this.purchase.purchaseLines[0].amount === 1) {
      this.purchase.completionStatus = PurchaseCompletionStatus.Editable;
    }
  }

  private sendForm() {
    if (!(this.purchase.client.user as any).profile.phone) {
      (this.purchase.client.user as any).profile.phone = 'SINDATOS';
    } else {
      (this.purchase.client.user as any).profile.phone = (this.purchase.client.user as any).profile.phone.replaceAll(/\s/g, '')
    }
    if (this.participantId === "new") {
      this.purchase.client.user.profile.postalCode = this.fiscalData.postalCode
      this.purchase.client.user.profile.country = this.fiscalData.country
      this.purchase.client.user.profile.town = this.fiscalData.town
      this.purchase.client.user.profile.state = this.fiscalData.state
      this.purchase.client.user.profile.address = this.fiscalData.address
      this.purchase.fiscalData = this.fiscalData
    }
    const newPurchase = this.purchase;
    this.setPaymentStatus();
    this.setCompletionStatus();

    if (this.checkMandatoryFields() && this.checkMandatoryFieldsAddFiscalData() && !this.updateFiscalDataExtension && (this.savedFiscalDataBool === Boolean(this.fiscalData.user))) {
      this.checkEmail(() => {
        this.disableSendFormBtn = true;
        this.$store.dispatch("newPurchase", { newPurchase }).then(
          res => {
            this.savedFiscalDataBool = false
            this.$router.push({
              name: RouteNames.cbPariticipantList,
              params: { id: this.convocationId }
            });
            this.fiscalData = {
              'user': '',
              'userId': '',
              'email': '',
              'address': '',
              'postalCode': '',
              'country': '',
              'town': '',
              'state': '',
              'firstName': '',
              'lastName': '',
              'secondLastName': '',
              'nif': '',
              'phone': ' ',
              'id': '',
              'isDefault': false
            };
          },
          err => {
            this.setPurchaseFormError(err);
            this.checkServerError(err);
            this.disableSendFormBtn = false;
          }
        );
      });
    } else if (!this.checkMandatoryFieldsAddFiscalData() || this.updateFiscalDataExtension || !this.savedFiscalDataBool) {
      this.checkServerError({ 'response': { 'statusText': 'No has dado a Facturar aquí: Bad Request: Bloque Facturación.' } })
    } else if (this.purchase.paymentMethod == 2 && !this.purchase.cardLastDigits) {
      this.checkServerError({ 'response': { 'statusText': 'No has indicado los 4 dígitos de la tarjeta: Bad Request: 4 dígitos de tarjeta.' } })
    } else if (!this.purchase.fiscalDataExtensionId) {
      this.checkServerError({ 'response': { 'statusText': 'Bad Request: Datos fiscales insuficientes.' } })
    }
  }

  public searchCallback() {
    if (this.searchString === "") {
      this.selectedClient = null;
    }
    if (this.searchString != "") {
      this.searchPhoneString = ""
    }
    if (this.searchString != "" || this.searchPhoneString != "+34") {
      this.fetchClientList();
    }
  }

  private fetchClientList() {
    const payload = {
      limit: 20,
      search: this.searchString,
      searchPhone: this.searchPhoneString
    };
    this.$store.dispatch("fetchClientList", payload);
  }

  private async selectClient(option: any) {
    this.selectedClient = option;

    if (this.selectedClient.status == 1) {
      this.clientType = "Potencial";
    } else if (this.selectedClient.status == 2) {
      this.clientType = "Comprador";
    } else {
      this.clientType = "Potencial";
    }
    this.fillFormExistingClient();
    setTimeout(() => {
      this.fetchAquiredCourses();
    }, 1000);
  }

  private fillFormExistingClient() {
    (this.purchase.client.user as any).id = this.selectedClient.id;
    (this.purchase.client
      .user as any).firstName = this.selectedClient.firstName;
    (this.purchase.client
      .user as any).lastName = this.selectedClient.lastName;
    (this.purchase.client
      .user as any).secondLastName = this.selectedClient.secondLastName;
    (this.purchase.client
      .user as any).profile.nif = this.selectedClient.nif;
    (this.purchase.client
      .user as any).profile.phone = this.selectedClient.phone;
    // (this.purchase.client
    //   .user as any).profile.town = this.selectedClient.town;
    // (this.purchase.client
    //   .user as any).profile.address = this.selectedClient.address;
    // (this.purchase.client
    //   .user as any).profile.postalCode = this.selectedClient.postalCode;
    (this.purchase.client
      .user as any).email = this.selectedClient.email;
  }

  private fillFiscalDataFormExistingClient() {
    let defaultExtension = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.isDefault);
    if (defaultExtension.length > 0) {
      this.fiscalData = {
        'user': this.acquiredCourses.userId,
        'userId': '',
        'email': this.acquiredCourses.fiscalData.email,
        'address': this.acquiredCourses.fiscalData.address,
        'postalCode': this.acquiredCourses.fiscalData.postalCode,
        'country': this.acquiredCourses.fiscalData.country,
        'town': this.acquiredCourses.fiscalData.town,
        'state': this.acquiredCourses.fiscalData.state,
        'firstName': this.acquiredCourses.fiscalData.firstName,
        'lastName': this.acquiredCourses.fiscalData.lastName,
        'secondLastName': this.acquiredCourses.fiscalData.secondLastName,
        'nif': this.acquiredCourses.fiscalData.nif,
        'phone': this.acquiredCourses.fiscalData.phone,
        'id': defaultExtension[0].id,
        "isDefault": true
      }
    } else {
      this.fiscalData = {
        'user': this.acquiredCourses.userId,
        'userId': '',
        'email': this.purchase.client.user.email || 'SIN@DATOS.COM',
        'address': this.purchase.client.user.profile.address || 'SIN DATOS',
        'postalCode': this.purchase.client.user.profile.postalCode || '',
        'country': this.purchase.client.user.profile.country || 'SIN DATOS',
        'town': this.purchase.client.user.profile.town || 'SIN DATOS',
        'state': this.purchase.client.user.profile.state || 'SIN DATOS',
        'firstName': this.purchase.client.user.firstName || 'SIN DATOS',
        'lastName': this.purchase.client.user.lastName || 'SIN DATOS',
        'secondLastName': this.purchase.client.user.secondLastName || 'SIN DATOS',
        'nif': this.purchase.client.user.profile.nif || '',
        'phone': this.purchase.client.user.profile.phone || '34',
        'id': '',
        "isDefault": true
      }
      this.isDefaultFiscalData = false;
      // this.isNewFiscalDataExtension = true;
    }
  }

  private duplicateFiscalData() {
    this.fiscalData = {
      'user': this.acquiredCourses.userId,
      'userId': '',
      'email': this.purchase.client.user.email || 'SIN@DATOS.COM',
      'address': this.purchase.client.user.profile.address || 'SIN DATOS',
      'postalCode': this.purchase.client.user.profile.postalCode || '',
      'country': this.purchase.client.user.profile.country || 'SIN DATOS',
      'town': this.purchase.client.user.profile.town || 'SIN DATOS',
      'state': this.purchase.client.user.profile.state || 'SIN DATOS',
      'firstName': this.purchase.client.user.firstName || 'SIN DATOS',
      'lastName': this.purchase.client.user.lastName || 'SIN DATOS',
      'secondLastName': this.purchase.client.user.secondLastName || 'SIN DATOS',
      'nif': this.purchase.client.user.profile.nif || '',
      'phone': this.purchase.client.user.profile.phone || '34',
      'id': '',
      "isDefault": true
    }
  }

  private clearClient() {
    this.selectedClient = null;
  }

  private DeleteHandleClick() {
    this.deleteModalToggle(true);
  }

  private deleteModalToggle(value: boolean) {
    this.isDeleteModalOpened = value;
  }

  private deleteClient() {
    this.$store.dispatch("deleteClient", { id: this.purchase.client.user.id }).then((res) => {
      this.deleteModalToggle(false);
      setTimeout(() => {
        this.$router.push({
          name: RouteNames.cbPariticipantList,
          params: { id: this.convocationId }
        });
      }, 2000);
    });
  }

  get client() {
    if (this.selectedClient && this.selectedClient.id) {
      return this.getClient(this.selectedClient.id);
    } else if (this.purchase && this.purchase.client && this.purchase.client.user && this.purchase.client.user.id) {
      return this.getClient(this.purchase.client.user.id);
    }

  }

  get clientSelectedName() {
    let name = "SIN CLIENTE ASOCIADO:";
    if (this.hasClientSelected) {
      name = (this.currentPurchase.client.user as any).fullName;
    }
    return name;
  }


  private duplicateFiscalDataExtension() {
    this.fiscalData = {
      'user': this.acquiredCourses.userId,
      'userId': '',
      'email': this.purchase.client.user.email || 'SIN@DATOS.COM',
      'address': this.purchase.client.user.profile.address || 'SIN DATOS',
      'postalCode': this.purchase.client.user.profile.postalCode || '',
      'country': this.purchase.client.user.profile.country || 'SIN DATOS',
      'town': this.purchase.client.user.profile.town || 'SIN DATOS',
      'state': this.purchase.client.user.profile.state || 'SIN DATOS',
      'firstName': this.purchase.client.user.firstName || 'SIN DATOS',
      'lastName': this.purchase.client.user.lastName || 'SIN DATOS',
      'secondLastName': this.purchase.client.user.secondLastName || 'SIN DATOS',
      'nif': this.purchase.client.user.profile.nif || '',
      'phone': this.purchase.client.user.profile.phone || '34',
      'id': '',
      "isDefault": true
    }
  }

  get searchAutocompletePlaceholder() {
    return "Buscar datos fiscales";
  }

  public searchFDCallback() {
    if (this.searchStringFiscalData === "") {
      this.selectedOptionFiscalData = null;
    }
    this.fetchClientFiscalDataExtension();
  }

  private fetchClientFiscalDataExtension() {
    const payload = {
      limit: 20,
      search: this.searchStringFiscalData
    };
    this.$store.dispatch("fetchFiscalDataExtension", payload)
      .then((res) => {
        this.searchFiscalDataExtensionsList = res.results
      });;
  }

  private selectFiscalData(option: any, modifyPurchase?: any, index?: any) {
    this.selectedOptionFiscalData = option;
    this.selectedClientFiscalData = this.searchFiscalDataExtensionsList.filter((item: any) => item.id == this.selectedOptionFiscalData.id)[0]

    if (this.selectedClientFiscalData) {
      this.fiscalData = {
        'user': this.purchase.client.user.id || '',
        'userId': '',
        'email': this.selectedClientFiscalData.email || 'SIN@DATOS.COM',
        'address': this.selectedClientFiscalData.address || 'SIN DATOS',
        'postalCode': this.selectedClientFiscalData.postalCode,
        'country': this.selectedClientFiscalData.country || 'SIN DATOS',
        'town': this.selectedClientFiscalData.town || 'SIN DATOS',
        'state': this.selectedClientFiscalData.state || 'SIN DATOS',
        'firstName': this.selectedClientFiscalData.firstName || 'SIN DATOS',
        'lastName': this.selectedClientFiscalData.lastName || 'SIN DATOS',
        'secondLastName': this.selectedClientFiscalData.secondLastName || 'SIN DATOS',
        'nif': this.selectedClientFiscalData.nif,
        'phone': this.selectedClientFiscalData.phone || '34',
        'id': '',
        "isDefault": true
      }
    }
  }

  private rescatarFiscalDataExtension() {
    this.rescatarFiscalDataBool = true
  }


  private showAddPaymentInfo(value: Boolean) {
    if (value == true) {
      this.setCurrentBudget(new Budget());
    }
    this.showAddPaymentInfoBoolean = value;
  }

  @Watch("clientPaymentSelected")
  private watchClientPaymentSelected(newVal: any, oldVal: any) {
    if (newVal != undefined && newVal.active == false && oldVal != undefined && oldVal != "") {
      this.updateClientPayment(newVal)
    }
  }


  private updateClientPayment(newVal: any) {
    newVal.active = true
    this.$store
      .dispatch("updateClientPayment", { id: this.purchase.client.user.id, viewStatus: 0, ...newVal })
      .then((res) => {
        if (res.message != '') {
          // this.showNotification(res.message);
          this.fetchClientPayment(0)
        }
      })
      .catch((err) => {
        this.showNotification(err.error, SpotlightTextColor.Error);
      });
  }

  private fetchClientPayment(viewStatus: number) {
    this.$store
      .dispatch("fetchClientPayment", { id: this.purchase.client.user.id, viewStatus: viewStatus })
      .then((res) => {
        this.clientPayments = res.data.filter((item: any) => item.status != 1)
        this.clientPaymentSelected = this.clientPayments.filter((item: any) => item.active)[0]
        if (!this.clientPaymentSelected) {
          this.clientPaymentSelected = this.clientPayments[0]
        }
        if (res.info != '') {
          this.showNotification(res.info, SpotlightTextColor.Error);
        }
        this.$forceUpdate();
      });
  }

  get creditCardFormated() {
    const creditCard = Object.assign({}, this.currentBudget.creditCard);
    const splittedDate = creditCard.dateExpiration.split('/');
    const month = Number(splittedDate[0]) - 1;

    let dateDayjs = dayjs();
    let year = dateDayjs.year().toString();
    year = year.substring(0, year.length - 2);
    year += splittedDate[1];
    dateDayjs = dateDayjs
      .set('date', 1)
      .set('month', month)
      .set('year', Number(year));
    creditCard.dateExpiration = dateDayjs.toISOString();
    const purchaseLine = this.purchase.purchaseLines[0]
    if (purchaseLine && purchaseLine.product){
      creditCard.relatedProduct =  purchaseLine.product.name;
    }
    return creditCard;
  }

  private getPaymentInfo() {
    let info = {};
    if (this.isCardMethodSelected) {
      info = { creditCard: this.creditCardFormated };
    } else if (this.isDirectDebitMethodSelected) {
      // const bankId = this.currentBudget.bankAccount.bank.id;
      // this.currentBudget.bankAccount.bank = bankId;
      if (process.env.VUE_APP_DEBUG) {
        // this.currentBudget.bankAccount.bank = "572a9108-f910-4cb6-942c-cedb529e29e3";
        this.currentBudget.bankAccount.bank = "ec3215aa-a207-457a-865b-dca79c864263";
      } else {
        // this.currentBudget.bankAccount.bank = "7591c2a8-691c-4862-aa57-fc374e9117a2";
        this.currentBudget.bankAccount.bank = "ec3215aa-a207-457a-865b-dca79c864263";
      }
      const purchaseLine = this.purchase.purchaseLines[0]
      if (purchaseLine && purchaseLine.product){
        this.currentBudget.bankAccount.relatedProduct =  purchaseLine.product.name;
      }
      info = { bankAccount: this.currentBudget.bankAccount };
    }
    return info;
  }

  private addPaymentInfo() {
    if (this.checkFormValidation()) {
      this.newPaymentAdded = true
      let errorNotification = null;
      let holder = null;

      if (this.isCardMethodSelected) {
        holder = this.currentBudget.creditCard.holder;
      } else if (this.isDirectDebitMethodSelected) {
        holder = this.currentBudget.bankAccount.holder;
      }

      if (holder && this.fullName !== holder) {
        errorNotification = "El nombre del titular ha de ser igual al NOMBRE del cliente actual";
      }

      if (errorNotification) {
        this.showNotification(errorNotification, SpotlightTextColor.Error);
        this.newPaymentAdded = false
      } else {
        this.showAddPaymentInfo(false)
        this.$store
          .dispatch("newClientPayment", { id: this.purchase.client.user.id, viewStatus: 0, ...this.getPaymentInfo() })
          .then((res) => {
            this.fetchClientPayment(0)
            this.showNotification(res.message);
            this.newPaymentAdded = false
          })
          .catch((err) => {
            this.showNotification(err.message, SpotlightTextColor.Error);
            this.newPaymentAdded = false
          });
      }
    }
  }

  private checkFormValidation() {
    if (
      this.currentBudget.paymentMethod.toString() ===
      BudgetPaymentMethod.DirectDebit.toString()
    ) {
      return this.directDebitFieldsValidation();
    } else if (
      this.currentBudget.paymentMethod.toString() ===
      BudgetPaymentMethod.Card.toString()
    ) {
      return this.cardFieldsValidation();
    }
  }

  private directDebitFieldsValidation() {
    if (this.currentBudget.bankAccount) {
      const error: any = { bankAccount: {}, budgetSepaInfo: {} };
      const emptyField = 'Campo vacío';
      const errorField = 'Campo incorrecto';
      var errores = false
      // if (!(this.currentBudget.bankAccount as any).bank) {
      //   error.bankAccount['bank'] = emptyField;
      // }
      const bankNumber = (this.currentBudget.bankAccount as any).number;
      if (!bankNumber) {
        error.bankAccount['number'] = emptyField;
        errores = true
      } else if (bankNumber.trim().length < 24) {
        error.bankAccount['number'] = errorField;
        errores = true
      }
      if (!(this.currentBudget.bankAccount as any).holder) {
        error.bankAccount['holder'] = 'Dale al botón COPIAR TITULAR';;
        errores = true
      }
      if (!(this.currentBudget.bankAccount as any).number) {
        error.bankAccount['number'] = emptyField;
        errores = true
      }

      if (errores) {
        this.setAcceptanceFieldError(error);
        return false
      } else {
        return true
      }
    }
  }

  private cardFieldsValidation() {
    if (this.currentBudget.creditCard) {
      const error: any = { creditCard: {} };
      const emptyField = 'Campo vacío';
      const errorField = 'Campo incorrecto';
      var errores = false

      const cardNumber = (this.currentBudget.creditCard as any).number;
      if (!cardNumber) {
        error.creditCard['number'] = emptyField;
        errores = true
      } else if (cardNumber.trim().length < 16) {
        error.creditCard['number'] = errorField;
        errores = true
      }
      const dateExpiration = (this.currentBudget.creditCard as any)
        .dateExpiration;
      if (!dateExpiration) {
        error.creditCard['dateExpiration'] = emptyField;
        errores = true
      } else if (dateExpiration.trim().length < 5) {
        error.creditCard['dateExpiration'] = errorField;
        errores = true
      }
      const cvv = (this.currentBudget.creditCard as any).cvv;
      if (!cvv) {
        error.creditCard['cvv'] = emptyField;
        errores = true
      } else if (cvv.trim().length < 3) {
        error.creditCard['cvv'] = errorField;
        errores = true
      }
      if (!(this.currentBudget.creditCard as any).holder) {
        error.creditCard['holder'] = 'Dale al botón COPIAR TITULAR';;
        errores = true
      }

      if (errores) {
        this.setAcceptanceFieldError(error);
        return false
      } else {
        return true
      }
    }
  }

  private setAcceptanceFieldError(error: any) {
    const newError = error;
    this.$store.commit('setAcceptanceFieldError', newError);
  }

  private copyHolderName() {
    if (this.currentBudget.paymentMethod.toString() ===
      BudgetPaymentMethod.DirectDebit.toString()) {
      this.currentBudget.bankAccount.holder = this.fullName
    } else if (this.currentBudget.paymentMethod.toString() ===
      BudgetPaymentMethod.Card.toString()) {
      this.currentBudget.creditCard.holder = this.fullName
    }

    this.setCurrentBudget(this.currentBudget)

    // Forzar refresco de los componentes hijos
    const choosePaymentMethodComponent = this.$refs.componentePagoAplazado as ChoosePaymentMethod
    if (choosePaymentMethodComponent.$children) {
      choosePaymentMethodComponent.$children.forEach((child: any) => {
        child.$forceUpdate()
      });
    }

  }
}
